import { getSeoData } from '../../../api/getSeoData';
import { isClient } from '../../../utils';
import { checkInvalidSeoFields } from '../../../utils/seo';
import { IThunkActionCreator } from '../../../types/store';
import { ISeoPageData } from '../../../types/seo';

export enum SeoDataActionTypes {
  Fetched = 'SeoDataFetched',
}

export interface ISeoDataFetched {
  data?: ISeoPageData;
  type: SeoDataActionTypes.Fetched;
}

export function fetchSeoData(): IThunkActionCreator<Promise<void>> {
  return async (dispatch, getState, { httpApi, logger, subdomain }) => {
    if (!isClient()) {
      return;
    }

    const url = window.location.pathname;

    const pageSeoData = await getSeoData(httpApi, logger, { uri: url, subdomain });

    dispatch<ISeoDataFetched>({
      data: pageSeoData,
      type: SeoDataActionTypes.Fetched,
    });

    if (pageSeoData && checkInvalidSeoFields(pageSeoData.seoData)) {
      logger.error('Found incorrect tags in seo templates', {
        message: { seoData: JSON.stringify(pageSeoData.seoData), url },
      });
    }
  };
}

export type TSeoDataAction = ISeoDataFetched;
